
<div class="risk_table">
    <div class="header_row">
        <div class="row">
            <div class="col text-left flag_header">
                {{ $t("overview.flags.header.0") }}
            </div>
            <div class="col col-2 col-xxl-1 text-right flag_header">
                {{ $t("overview.flags.header.1") }}
            </div>
            <div class="col col-auto">
                &nbsp;
            </div>
        </div>
    </div>

    <template v-for="(group, i) in flags">
        <div
            :key="`flag-group-${i}`"
            class="data_row clickable"
            @click="expanded.includes(i) ? expanded.splice(expanded.indexOf(i), 1) : expanded.push(i)"
            :class="{ clickable: clickableRows }"
        >
            <div class="row align-items-center">
                <div class="col text-left">
                    <RiskLevelDumpling :value="group.risk" :level="versionRiskLevel(group, version)" />

                    {{ group.name }}

                    <a v-on:click.stop="" :href="flagUrl(group.documentation_url)" target="_blank"  v-if="group.documentation_url">
                        <b-icon-question-circle
                            font-scale="0.95"
                            variant="dark"
                            class="ml-1"
                        />
                    </a>
                </div>
                <div class="col col-2 text-right numeric_column">{{ formatInteger(group.count) }}x</div>
                <div class="col col-auto" v-show="version == 'lite' || version == 'full'">
                    <IndicatorBar
                    :widthBar="100"
                    :value="group.percent"
                    :tooltips="tooltips"
                    :saveZone="saveZone"
                    :ratio="group.ratio"
                    v-show="group.show"
                    />
                </div>
                <div class="col col-auto group_caret"><AnimatedCaret :expanded="expanded.includes(i)" /></div>
            </div>
        </div>

        <template v-if="expanded.includes(i)">
            <div
                v-for="(f, j) in group['flags']"
                :key="`flag-${i}-${j}`"
                class="data_row sub"
                :class="{clickable: clickableRows}"
                v-on="clickableRows ? { click: () => $emit('row-clicked', f) } : {}"
            >
                <div class="row align-items-center">
                    <div class="col text-left">
                        <RiskLevelDumpling :value="f.risk" :level="versionRiskLevel(f, version)" />

                        {{ f.name }}

                        <a v-on:click.stop="" :href="flagUrl(f.documentation_url)" target="_blank" v-if="f.documentation_url">
                            <b-icon-question-circle
                                font-scale="0.95"
                                variant="dark"
                                class="ml-1"
                            />
                        </a>
                    </div>
                    <div class="col col-2 text-right numeric_column">{{ formatInteger(f.count) }}x</div>
                    <div class="col col-auto" v-show="version == 'lite' || version == 'full'">
                        <IndicatorBar
                        :widthBar="100"
                        :value="f.percent"
                        :tooltips="tooltips"
                        :saveZone="saveZone"
                        :ratio="f.ratio"
                        v-show="f.show"
                        />
                    </div>
                </div>
            </div>
        </template>
    </template>
</div>
